import { render, staticRenderFns } from "./BenefitsSection.vue?vue&type=template&id=367bdefa&scoped=true"
import script from "./BenefitsSection.vue?vue&type=script&lang=js"
export * from "./BenefitsSection.vue?vue&type=script&lang=js"
import style0 from "./BenefitsSection.vue?vue&type=style&index=0&id=367bdefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367bdefa",
  null
  
)

export default component.exports